import * as React from 'react'
import Socket from '../../../Socket/socket-init'
// import { Main } from '../../../Logic/Main'
// import { Logic } from '../../../Logic/Type'
import * as Utils from '../../../Logic/Utils'
import * as Assets from '../../../assets/Assets'
import * as Body from './Body'
// import * as RouteClasses from '../../../Socket/route-classes'
import { Link } from 'react-router-dom'
import { Cookies, withCookies } from 'react-cookie'
import * as moment from 'moment'
import Loader from './Loader'

interface IState {
    userDropdown: boolean
    resultsRound: number
    mobileMenu: boolean
    roundsDropdown: boolean
    chosenRound: string
    totalCorrectScore: number
    popup: boolean
    pointsSystem: number
}

class Results extends React.Component<{location: {state: any}}, IState> {

    public cookies

    constructor(props) {
        super(props)

        window.scroll(0, 0)

        this.cookies = new Cookies()

        window.onload = () => {
            Socket.Send('results', {playerId: this.props.location.state.playerId, round: this.props.location.state.resultsRound})
            Socket.Send('rounds', {playerId: this.props.location.state.playerId})
        }

        this.state = {
            userDropdown: false,
            resultsRound: this.props.location.state.resultsRound,
            mobileMenu: false,
            roundsDropdown: false,
            chosenRound: 'GAMEWEEK ' + this.props.location.state.resultsRound.toString(),
            totalCorrectScore: 0,
            popup: false,
            pointsSystem: 0
        }
        
    }

    render() {
        if ((Socket.Get<any>('results')).loading !== 'loaded' || Socket.Get<any>('rounds').loading !== 'loaded') {
            return <Loader/>
        } else {
            const results = Socket.Get<any>('results').results
            return (
                <section className="wrapper">
                    <div className="header" role="banner">
                        <header className="navbar navbar-default" style={{ marginBottom: '0' }}>
                            <div className="container">
                                <div className="navbar-header">
                                    <button 
                                        onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                        type="button" 
                                        className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'} 
                                        data-toggle="collapse" 
                                        data-target="#navbar-collapse-mid" 
                                        aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    <span style={(this.state.mobileMenu) ? { background: 'rgb(41, 160, 0)' } : null} className="icon-bar" />
                                    </button>                                  
                                    <Link className="navbar-brand" to="/">
                                    <img src={Assets.logoMain} alt="" className="logo" />
                                    </Link> 
                                    <span className="navbar-toggle user-profile-trigger">{this.cookies.get('username')}</span>
                                </div>
                                <nav 
                                    className={(this.state.mobileMenu) ? 'navbar-collapse navbar-left collapse in' : 'navbar-collapse navbar-left collapse'} 
                                    id="navbar-collapse-left"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    style={(this.state.mobileMenu) ? { height: 'auto' } : { height: '1px' }}
                                >
                                    {(this.cookies.get('username')) ? Body.getMenu('pull-left', Assets.mobileMenuLeft) : Body.getMenu('pull-left', Assets.mobileMenuLeftLogin)}
                                </nav>
                                <nav className="collapse navbar-collapse" id="user-profile">
                                    <ul className="nav navbar-nav navbar-right">
                                        <li className="user-nav-option">
                                            <div className="user">
                                                <div className="user-info-wrap"> <span className="user-name">{this.cookies.get('username')}</span>
                                                    <div className="balance-info"> Balance<span className="text-primary">5,000 € </span>
                                                        <a href="javascript:void(0);"><i className="icon-plus-circular"/></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {(this.cookies.get('username')) ? 
                                        <li className={(this.state.userDropdown === true) ? 'dropdown open' : 'dropdown'}>
                                            <a href="javascript:void(0);" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded={(this.state.userDropdown) ? 'true' : 'false'}>
                                                <i className="icon-menu-dots" onClick={() => this.setState({userDropdown: !this.state.userDropdown})}/>
                                            </a>
                                            <ul className="dropdown-menu">
                                                    <li><Link to="/myprofile"><i className="icon-profile"/>MY PROFILE</Link></li>
                                                    <li onClick={() => Utils.logout()}>
                                                    <Link to="/login">
                                                        <i className="icon-logout"/>
                                                        LOGOUT
                                                    </Link>
                                                    </li>
                                            </ul>
                                        </li>
                                        :
                                        null}
                                    </ul>
                                </nav>
                            </div>
                        </header>
                    </div>
                    <div className="info-ribbon">
                        <div className="container">
                            <div className="h4 text-center">
                                {this.state.chosenRound}
                            </div>
                        </div>
                    </div>
                    <main className="main">
                        <div className="container">
                            <div className="page-header outer-header mTzero h5 results-header" >
                                <div className="row">
                                    <div className="col-sm-4 results-header-30">Name : <b>{results.username}</b></div>
                                    <div className="col-sm-4 results-header-30">Score : <b>{(results.totalCorrectScores + results.totalCorrectScoresBonus + results.correctScoresBonus + results.totalAccumulator + results.accumulatorBonus + results.totalGoalscorers + results.goalscorersBonus).toFixed(2)}</b></div>
                                    <div className="col-sm-4 right results-header-40">
                                        <div className="row">
                                            <div className="col-xs-4 leaderboard-round">
                                                <label style={{ fontWeight: 'normal' }}>Round</label>
                                            </div>
                                            <div className="col-xs-8">
                                                <span onClick={() => this.setState({ roundsDropdown: !this.state.roundsDropdown })} className={(this.state.roundsDropdown) ? 'results-round-selection select2 select2-container select2-container--default select2-container--below select2-container--focus select2-container--open' : 'results-round-selection select2 select2-container select2-container--default select2-container--below select2-container--focus'} dir="ltr">
                                                    <span className="selection">
                                                        <span className="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded={(this.state.roundsDropdown) ? 'true' : 'false'} aria-labelledby="select2--cy-container" aria-owns={(this.state.roundsDropdown) ? 'select2--cy-results' : null}>
                                                            <span className="select2-selection__rendered" id="select2--cy-container" title="MD 1">{this.state.chosenRound}</span>
                                                            <span className="select2-selection__arrow" role="presentation">
                                                                <b role="presentation"/>
                                                            </span>
                                                        </span>
                                                    </span>
                                                    <span className="dropdown-wrapper" aria-hidden="true"/>
                                                </span>
                                                {(this.state.roundsDropdown) ?
                                                <span className="select2-container select2-container--default select2-container--open">
                                                    <span className="select2-dropdown select2-dropdown--below results-round-selection" style={{ display: 'inline-block' }} dir="ltr">
                                                        <span className="select2-search select2-search--dropdown select2-search--hide">
                                                            <input className="select2-search__field" type="search" role="textbox"/>
                                                        </span>
                                                        <span className="select2-results">
                                                            <ul className="select2-results__options" role="tree" id="select2--cy-results" aria-expanded="true" aria-hidden="false">
                                                                {this.getRoundsNames()}
                                                            </ul>
                                                        </span>
                                                    </span>
                                                </span>
                                                : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="stage-view">
                                <div className="stage-view-content">
                                    <div className="stage-view-header">
                                        <div className="stage-view-row">
                                            <div className="stage-view-cell stage-view-heading">
                                                <div className="pro">
                                                    <div className="relative-wrap">
                                                        Correct Score
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="stage-view-cell">
                                                Predictions
                                            </div>
                                            <div className="stage-view-cell" >
                                                Outcome
                                            </div>
                                            <div className="stage-view-cell">
                                                1X2 points
                                            </div>
                                            <div className="stage-view-cell">
                                                Bonus
                                            </div>
                                        </div>
                                    </div>
                                    <div className="stage-view-body">
                                        {this.setCorrectScores()}
                                    </div>
                                    <div className="check-points-system" onClick={() => this.setState({ popup: true, pointsSystem: 1 })}>
                                        <img src="info-black.png"/>
                                        <i>Check points system</i>
                                    </div>
                                </div>
                                <div className="stage-view-content">
                                    <div className="stage-view-header">
                                        <div className="stage-view-row">
                                            <div className="stage-view-cell stage-view-heading">
                                                <div className="pro">
                                                    <div className="relative-wrap">
                                                        Goal Markets
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="stage-view-cell">
                                                Outcome
                                            </div>
                                            <div className="stage-view-cell">
                                                Points
                                            </div>
                                        </div>
                                    </div>
                                    <div className="stage-view-body">
                                        {this.setAccumulator('Both teams to score')}
                                        {this.setAccumulator('Over 2.5 goals')}
                                        {this.setAccumulator('Under 2.5 goals')}
                                        {this.setAccumulator('Draw')}
                                        <div className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                                            <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                                            <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                                                Accumulator points
                                            </div>
                                            <div className="stage-view-cell accumulated-odds acc-odds-padding" data-span="Points">
                                                {results.totalAccumulator.toFixed(2)}
                                            </div>
                                        </div>
                                        <div className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                                            <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                                            <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                                                Triple bonus
                                            </div>
                                            <div className="stage-view-cell accumulated-odds acc-odds-padding" data-span="Points">
                                                {results.accumulatorBonus}
                                            </div>
                                        </div>
                                        <div className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                                            <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                                            <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="">
                                                Goal markets total
                                            </div>
                                            <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="">
                                                {(results.totalAccumulator + results.accumulatorBonus).toFixed(2)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="check-points-system" onClick={() => this.setState({ popup: true, pointsSystem: 2 })}>
                                        <img src="info-black.png"/>
                                        <i>Check points system</i>
                                    </div>
                                </div>
                                <div className="stage-view-content">
                                    <div className="stage-view-header">
                                        <div className="stage-view-row">
                                            <div className="stage-view-cell stage-view-heading">
                                                <div className="pro">
                                                    <div className="relative-wrap">
                                                        Goalscorers
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="stage-view-cell">
                                                Outcome
                                            </div>
                                            <div className="stage-view-cell">
                                                Points
                                            </div>
                                        </div>
                                    </div>
                                    <div className="stage-view-body">
                                        {this.setGoalscorers()}
                                    </div>
                                    <div className="check-points-system" onClick={() => this.setState({ popup: true, pointsSystem: 3 })}>
                                        <img src="info-black.png"/>
                                        <i>Check points system</i>
                                    </div>
                                </div>
                                <div className="stage-view-content" style={{ marginTop: '50px' }}>
                                    <div className="stage-view-body">
                                        <div className="stage-view-row">
                                            <div className="stage-view-cell total-points">Total</div>
                                            <div className="stage-view-cell total-points">{(results.totalCorrectScores + results.totalCorrectScoresBonus + results.correctScoresBonus + results.totalAccumulator + results.accumulatorBonus + results.totalGoalscorers + results.goalscorersBonus).toFixed(2)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {(this.state.popup) ? this.showPopup() : null}
                    </main>
                </section>
            )
        }
    }

    showPopup(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 200
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner" style={{ top }}>
                    <div className="check-points-system-popup">
                        <span className="team-players-name"><b>POINTS SYSTEM</b></span>
                        <span className="team-info-close"><img src="cancel.svg" onClick={() => this.setState({ popup: false })}/></span>
                    </div>
                    {(this.state.pointsSystem === 1) ?        
                    <div className="check-points-system-third">
                        <h3>Correct scores</h3>
                        <p>There are two parts to the points calculation in the Correct Score predictions...</p>
                        <p>Part 1 - Correct win/draw/win (1X2) outcome = Earn the 1X2 odds for that selection, as points.</p>
                        <p>Part 2 - Correct score at full time (90mins) = Additional bonus points according to the table below;</p>
                        <p>Correct score odds 1 &#8594; 9.99 | 2 points</p>
                        <p>Correct score odds 10 &#8594; 24.99 | 3 points</p>
                        <p>Correct score odds 25+ | 5 points</p>
                        <br/>
                        <p>1X2 points are multiplied together to get the 1X2 Accumulator points.</p>
                        <p>Then, Correct Score bonus points are multiplied and the two totals are added together.</p>
                        <p>A further bonus of 3 points is awarded if the user correctly predicts the win/draw/win (1X2) outcome of all 3 selections.
                            Or, a bonus of 9 points if the user correctly predicts all 3 correct scores!</p>
                    </div>
                    : (this.state.pointsSystem === 2) ?
                    <div className="check-points-system-third">
                        <h3>Goal markets</h3>
                        <p>User will earn the decimal odds of each correct selection, as points.
                            Points from each correct selection are multiplied together to give a Goal Markets total.</p>
                        <p>A further bonus of 3 points is awarded if the user correctly predicts a goal markets outcome in all 3 selections.</p>
                    </div>
                    :
                    <div className="check-points-system-third">
                        <h3>Goalscorers</h3>
                        <p>User will earn the decimal odds of each correct selection, as points.
                            Points from each correct selection are multiplied together to give a Goalscorers total.</p>
                        <p>A further bonus of 3 points is awarded if all three of the user´s selections score 1 goal or more.</p>
                    </div>
                    }
                </div>
            </div>
        )
    }

    getRoundsNames(): JSX.Element[] {
        const currentTime = moment().local()
        const rounds = Object.assign(Socket.Get('rounds')).rounds
        const roundsNames: JSX.Element[] = []
        for (let i = 0; i < rounds.length; i++) {
            const utcDeadline = moment.utc(rounds[i].deadline)
            const deadline = moment(utcDeadline).local()
            if (rounds[i].played && currentTime > deadline) {
                roundsNames.push(
                    <li 
                        key={roundsNames.length}
                        className="select2-results__option" 
                        role="treeitem" 
                        aria-selected={(this.state.chosenRound === rounds[i].roundName) ? 'true' : 'false'}
                        onClick={() => {this.changeType(rounds[i].roundId, rounds[i].played),
                                        this.setState({ chosenRound: rounds[i].roundName, roundsDropdown: false })}} 
                    >
                        {rounds[i].roundName}
                    </li>
                )
            }
        }
    
        return roundsNames
    }
    
    changeType(round: number, played: boolean) {
        this.setState({ resultsRound: round })
        const results = Socket.Get<any>('results').results
        if (played) {
            Socket.Send('results', { playerId: results.playerId, round })
        }
    }

    setCorrectScores(): JSX.Element[] {
        const scoresReturn: JSX.Element[] = []
        const scores = Socket.Get<any>('results').results
        for (const score of scores.correctScores) {
            scoresReturn.push(
                <div key={scoresReturn.length} className="stage-view-row">
                    <div className="stage-view-cell">
                        {score.homeTeam} <small className="text-gray vs">vs</small> {score.awayTeam}
                    </div>
                    <div className="stage-view-cell" data-span="Predictions">
                        {score.correctScore.name[0] + '-' + score.correctScore.name[2]}
                    </div>
                    <div className="stage-view-cell" data-span="Outcome">
                        {(score.result) ? ('(' + score.result[0] + '-' + score.result[2] + ')') : '-'}
                    </div>
                    <div className="stage-view-cell" data-span="1X2 points">
                        {(typeof +score.result === 'number') ? score.points : '-'}
                    </div>
                    <div className="stage-view-cell" data-span="Bonus">
                        {(typeof +score.result === 'number') ? score.bonus : '-'}
                    </div>
                </div>
            )
        }
        scoresReturn.push(
            <div key={scoresReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding mobile-hide" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" style={{ background: '#FFF' }}>
                    Accumulator points
                </div>
                <div className="stage-view-cell accumulated-odds acc-odds-padding mobile-color-green" data-span="1X2 points">
                    {scores.totalCorrectScores.toFixed(2)}
                </div>
                <div className="stage-view-cell accumulated-odds acc-odds-padding mobile-color-green" data-span="Bonus">
                    {scores.totalCorrectScoresBonus}
                </div>
            </div>
        )
        scoresReturn.push(
            <div key={scoresReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding mobile-hide" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" style={{ background: '#FFF' }}>
                    Triple bonus
                </div>
                <div className="stage-view-cell accumulated-odds acc-odds-padding mobile-hide" data-span="1X2"/>
                <div className="stage-view-cell accumulated-odds acc-odds-padding" data-span="Bonus">
                    {scores.correctScoresBonus}
                </div>
            </div>
        )
        scoresReturn.push(
            <div key={scoresReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding mobile-hide" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell accumulated-odds-total acc-odds-padding">
                    Correct score total
                </div>
                <div className="stage-view-cell accumulated-odds-total acc-odds-padding mobile-hide" data-span="1X2"/>
                <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="">
                    {(scores.totalCorrectScores + scores.totalCorrectScoresBonus + scores.correctScoresBonus).toFixed(2)}
                </div>
            </div>
        )
    
        return scoresReturn
    }

    setAccumulator(type: string): JSX.Element[] {
        let betType: string = ''
        if (type === 'Both teams to score') betType = 'BTTS'
        else if (type === 'Over 2.5 goals') betType = 'Over'
        else if (type === 'Under 2.5 goals') betType = 'Under'
        else betType = 'Draw'

        const accReturn: JSX.Element[] = []
        const types = Socket.Get<any>('results').results.accumulator.filter((elt) => elt.type === betType)
        if (types.length > 0) {
            accReturn.push(
                <div key={accReturn.length} className="stage-view-row stage-view-row-alt">
                    <div className="stage-view-cell" />
                    <div className="stage-view-cell-alt stage-view-cell"><span data-span={type}>{type}</span></div>
                    <div className="stage-view-cell" />
                </div>
            )
            for (const res of types) {
                accReturn.push(
                    <div key={accReturn.length} className="stage-view-row">
                        <div className="stage-view-cell"> {res.homeTeam + ' / ' + res.awayTeam} </div>
                        <div className="stage-view-cell" data-span="Outcome">{(res.result) ? ('(' + res.result[0] + '-' + res.result[2] + ')') : '-'}</div>
                        <div className="stage-view-cell" data-span="Points">{(typeof +res.points === 'number') ? res.points : '-'}</div>
                    </div>
                )
            }
        }
    
        return accReturn
    }

    setGoalscorers(): JSX.Element[] {
        const goalsReturn: JSX.Element[] = []
        const scorers = Socket.Get<any>('results').results
        for (const score of scorers.goalscorers) {
            goalsReturn.push(
                <div key={goalsReturn.length} className="stage-view-row">
                    <div className="stage-view-cell">
                        {score.correctScore.name + ' ('}<span style={(score.team !== 1) ? { color: '#AAA' } : {}}>{score.homeTeam}</span> <small className="text-gray vs"> vs </small> <span style={(score.team !== 2) ? { color: '#AAA' } : {}}>{score.awayTeam}</span>)
                    </div>
                    <div className="stage-view-cell" data-span="Outcome">{(typeof +score.result === 'number') ? score.result : '-'}</div>
                    <div className="stage-view-cell" data-span="Points">{(typeof +score.points === 'number') ? score.points : '-'}</div>
                </div>
            )
        }
        goalsReturn.push(
            <div key={goalsReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                    Accumulator points
                </div>
                <div className="stage-view-cell accumulated-odds acc-odds-padding" data-span="Points">
                    {scorers.totalGoalscorers.toFixed(2)}
                </div>
            </div>
        )
        goalsReturn.push(
            <div key={goalsReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell acc-odds-padding" data-span="Predictions" style={{ background: '#FFF' }}>
                    Triple bonus
                </div>
                <div className="stage-view-cell accumulated-odds acc-odds-padding" data-span="Points">
                    {scorers.goalscorersBonus}
                </div>
            </div>
        )
        goalsReturn.push(
            <div key={goalsReturn.length} className="stage-view-row acc-odds-padding" style={{ background: '#E7E7E7' }}>
                <div className="stage-view-cell acc-odds-padding" style={{ borderBottom: '1px solid #E7E7E7' }}/>
                <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="">
                    Goalscorers total
                </div>
                <div className="stage-view-cell accumulated-odds-total acc-odds-padding" data-span="">
                    {(scorers.totalGoalscorers + scorers.goalscorersBonus).toFixed(2)}
                </div>
            </div>
        )
    
        return goalsReturn
    }
}

export default withCookies(Results)


// WEBPACK FOOTER //
// ./src/Views/Main/Index/Results.tsx